import "slick-carousel";
import $ from "jquery";

class ImageCarousel {
  constructor() {
    $.fn.replaceTagName = function (f) {
      var g = [],
        h = this.length;
      while (h--) {
        var k = document.createElement(f),
          b = this[h],
          d = b.attributes;
        for (var c = d.length - 1; c >= 0; c--) {
          var j = d[c];
          k.setAttribute(j.name, j.value);
        }
        k.innerHTML = b.innerHTML;
        a(b).after(k).remove();
        g[h - 1] = k;
      }
      return $(g);
    };
  }

  init() {
    $(document).ready(function () {
      let length, $bar, $progress;
      $(".blocks-gallery-item").replaceTagName("div");
      $(".blocks-gallery-grid").replaceTagName("div");
      // return false
      $(".blocks-gallery-grid").each(function (index, element) {
        length = $(element).find(".blocks-gallery-item").length;
        // $(this).find('figcaption').remove()
        // $(this).find('img').attr({
        //   'height' : 'auto',
        //   'width'   : '100%'
        // })

        $(".blocks-gallery-item").each(function () {
          const $image = $(this).find("img");
          // console.log($image);
          const src = $image.attr("src");
          $(this).find("figure").remove();
          $(this).css("background-image", "url(" + src + ")");
        });

        $bar = $('<div class="progress" />').wrapInner("<span />");
        $progress = $bar.find("span");

        $(element).on("init", function () {
          var wt = 100 / length;
          $progress.css("width", wt + "%");
          $(this).append($bar);
        });

        $(element).on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            var wt = (100 / length) * (nextSlide + 1);
            $progress.css("width", wt + "%");
          },
        );

        $(element).slick({
          dots: true,
          arrows: true,
          mobileFirst: true,
          slidesToShow: 1,
          infinite: false,
          // adaptiveHeight: true,
          // variableWidth: true,
          customPaging: function (slider, i) {
            var n = ("0" + (i + 1)).slice(-2);
            return `<span class="dot" data-no="${n}">${n}</span>`;
          },
          // responsive: [
          //   {
          //     breakpoint: 1392,
          //     settings: {
          //       dots: true
          //     }
          //   }
          // ]
        });
      });
    });
  }
}

export default ImageCarousel;
